var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgListdash(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 99.6875 70.1875",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    height: 70.1875,
    opacity: 0,
    width: 99.6875,
    x: 0,
    y: 0
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.4375 69.4375L95.1875 69.4375C97.6875 69.4375 99.6875 67.4375 99.6875 64.9375C99.6875 62.4375 97.6875 60.4375 95.1875 60.4375L34.4375 60.4375C31.9375 60.4375 29.9375 62.4375 29.9375 64.9375C29.9375 67.4375 31.9375 69.4375 34.4375 69.4375Z",
    fill: "currentColor",
    fillOpacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.1875 70.1875L13.875 70.1875C16.75 70.1875 19.125 67.8125 19.125 64.9375C19.125 62 16.75 59.6875 13.875 59.6875L5.1875 59.6875C2.3125 59.6875 0 62 0 64.9375C0 67.8125 2.3125 70.1875 5.1875 70.1875Z",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.4375 39.625L95.1875 39.625C97.6875 39.625 99.6875 37.625 99.6875 35.125C99.6875 32.625 97.6875 30.625 95.1875 30.625L34.4375 30.625C31.9375 30.625 29.9375 32.625 29.9375 35.125C29.9375 37.625 31.9375 39.625 34.4375 39.625Z",
    fill: "currentColor",
    fillOpacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.1875 40.375L13.875 40.375C16.75 40.375 19.125 38 19.125 35.125C19.125 32.1875 16.75 29.875 13.875 29.875L5.1875 29.875C2.3125 29.875 0 32.1875 0 35.125C0 38 2.3125 40.375 5.1875 40.375Z",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.4375 9.8125L95.1875 9.8125C97.6875 9.8125 99.6875 7.8125 99.6875 5.3125C99.6875 2.8125 97.6875 0.8125 95.1875 0.8125L34.4375 0.8125C31.9375 0.8125 29.9375 2.8125 29.9375 5.3125C29.9375 7.8125 31.9375 9.8125 34.4375 9.8125Z",
    fill: "currentColor",
    fillOpacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.1875 10.5625L13.875 10.5625C16.75 10.5625 19.125 8.1875 19.125 5.3125C19.125 2.375 16.75 0.0625 13.875 0.0625L5.1875 0.0625C2.3125 0.0625 0 2.375 0 5.3125C0 8.1875 2.3125 10.5625 5.1875 10.5625Z",
    fill: "currentColor"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgListdash);
export default __webpack_public_path__ + "static/media/list.dash.e67a71afa3145683ab05e9ea8496e321.svg";
export { ForwardRef as ReactComponent };